window.isAnimatedLogoVisible = false;
requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    class AnimatedLogo extends HTMLElement {
      constructor() {
        super();
        this.lastScrollTop = -1;
        this.duration = new Number(this.dataset.delay);
        this.placeholderOpacityOffsetCoef = 1 + 0.15;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        const stickyHeader = document.getElementsByTagName('sticky-header')[0];

        if (stickyHeader) stickyHeader.animatedLogo = this;

        this.picture = document.getElementById('animated-logo-picture');
        this.absolutePicture = document.getElementById('animated-logo-absolute-picture');
        this.absolutePictureTransparent = document.getElementById('animated-logo-absolute-picture-transparent');
        this.headingLogo = document.getElementById('heading-logo');
        this.animatedLogoPlaceholder = document.getElementById('animated-logo-placeholder');
        this.headerSectionsWrapper = this.headingLogo.closest('.header-sections-wrapper');
        this.isCentered = this.classList.contains('animated-logo--centered');
        this.attachedPoint = this.dataset.attachedPoint;

        this.onScrollHandler = this.onScroll.bind(this);
        this.onResizeHandler = this.onResize.bind(this);




        themeBase.checkWindow();
        this.onScrollHandler(null, true);
        themeBase.onWindowLoadTrigger(() => this.onScrollHandler(null, true));
        setTimeout(() => this.onScrollHandler(null, true), 100);
        setTimeout(() => this.onScrollHandler(null, true), 500);
        window.addEventListener('throttleScroll', this.onScrollHandler);
        window.addEventListener('MutationObserver', this.onScrollHandler);
        window.addEventListener('throttle60fpsResize', this.onResizeHandler, false);

        setTimeout(() => this.fullLoaded = true, 1000);
      }

      disconnectedCallback() {
        window.removeEventListener('throttleScroll', this.onScrollHandler);
      }

      getBounds() {
        this.pictureBounds = themeBounds.get(this.picture);
        this.headingLogoBounds = themeBounds.get(this.headingLogo);
        this.headerSectionsWrapperBounds = themeBounds.get(this.headerSectionsWrapper);
      }

      onResize() {
        if (themeBase.isTouch) this.classList.add('animated-logo--static-mode');
      }

      onScroll(event, firstLoad) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;


        if (themeBase.isFreezeScrollEnable || (this.lastScrollTop === scrollTop && this.fullLoaded)) return;


        this.getBounds();
        const stickyHeaderLogoTopSpace = this.headingLogoBounds.top - this.headerSectionsWrapper.offsetTop;
        const reductionRangeOffsetCorrection = this.attachedPoint === 'top' ? 0 :
          this.attachedPoint === 'center' ? this.pictureBounds.height / 2 :
          this.pictureBounds.height;
        const reductionRange = this.picture.offsetTop - stickyHeaderLogoTopSpace + reductionRangeOffsetCorrection;
        const dynamicsReductionRange = reductionRange - scrollTop;
        const ratioRangeOrigin = Math.max(0, Math.min(1, dynamicsReductionRange / reductionRange));

        if (this.currentRatioRangeOrigin === ratioRangeOrigin && this.currentPictureBoundsBottom === this.pictureBounds.bottom) return;

        const percentReductionRangeOrigin = ratioRangeOrigin * 100;
        const percentReductionRange = 100 - percentReductionRangeOrigin;
        const pictureWidthRande = this.pictureBounds.width - this.headingLogoBounds.width;
        const pictureWidthNewValue = this.pictureBounds.width - pictureWidthRande / 100 * Math.min(percentReductionRange, 100);
        const pictureWidthNewScale = (pictureWidthNewValue / this.pictureBounds.width).toFixed(4);
        const pictureDuration = firstLoad === true || this.duration === 0 ? 0 : Math.max(this.duration - this.duration / 100 * percentReductionRange, 0);
        const animatedLogoPlaceholderOpacity = Math.max(1 - percentReductionRange / 100 * this.placeholderOpacityOffsetCoef, 0);
        const absolutePictureTranslateY = this.pictureBounds.bottom - this.pictureBounds.height * ratioRangeOrigin;


        this.style.setProperty('--absolute-picture-translateY', `${absolutePictureTranslateY / 10}rem`);
        this.style.setProperty('--absolute-picture-scale', `scale(${pictureWidthNewScale})`);
        this.style.setProperty('--absolute-picture-transition-duration', `${pictureDuration}ms`);

        if (!this.isCentered) {
          this.style.setProperty('--absolute-picture-left', `${50 * ratioRangeOrigin}%`);
        }
        if (this.animatedLogoPlaceholderOpacity !== animatedLogoPlaceholderOpacity) {
          this.animatedLogoPlaceholder.style.opacity = animatedLogoPlaceholderOpacity;
        }

        const isInvisible = percentReductionRange >= 100;

        this.absolutePicture.classList[isInvisible ? 'add' : 'remove']('is-invisible');
        this.absolutePictureTransparent.classList[isInvisible ? 'add' : 'remove']('is-invisible');
        this.headingLogo.classList[isInvisible ? 'remove' : 'add']('is-invisible');
        this.classList[themeBounds.get(this.absolutePicture).top < this.headerSectionsWrapperBounds.bottom ? 'add' : 'remove']('animated-logo--crosses-navigation');
        this.animatedLogoPlaceholderOpacity = animatedLogoPlaceholderOpacity;

        this.currentRatioRangeOrigin = ratioRangeOrigin;
        this.currentPictureBoundsBottom = this.pictureBounds.bottom;

        if (!this.wasInisible) {
          window.isAnimatedLogoVisible = this.pictureBounds.top > 0;

          if (!window.isAnimatedLogoVisible) {
            this.wasInisible = true;
          }
        }

        if (!this.initialized &&
          (this.lastScrollTop > 0 || absolutePictureTranslateY > 0) &&
          this.pictureBounds.height
        ) {
          this.classList.add('animated-logo--initialized');
          this.initialized = true;
        }

        this.lastScrollTop = scrollTop;
      }
    }

    customElements.define('animated-logo', AnimatedLogo);
  });
});